export const GARDEN_PATH = '/promo/tovary-dlya-sada-i-ogoroda/';

export const GARDEN_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/garden-3';
